import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type PendingDialog = {
  dialogName: string
  dialogProps?: Record<string, unknown>
} | null

const initialState = {
  isMenuOpened: false,
  pendingDialog: null as PendingDialog,
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMenu: (state, action: PayloadAction<boolean>) => {
      state.isMenuOpened = action.payload
    },
    setPendingDialog: (state, action: PayloadAction<PendingDialog>) => {
      state.pendingDialog = action.payload
    },
    clearPendingDialog: (state) => {
      state.pendingDialog = null
    },
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof uiSlice.actions>>

export const { actions } = uiSlice
